// @ts-ignore
import CT from "colorthief/dist/color-thief.umd.js"

export class ColorThief {
  colorthief: any

  constructor() {
    this.colorthief = new CT()
  }

  getColor(img: HTMLImageElement, quality?: number): Promise<[number, number, number]> {
    return this.colorthief.getColor(img, quality)
  }

  getPalette(img: HTMLImageElement, colorCount?: number, quality?: number): Promise<[number, number, number][]> {
    return this.colorthief.getPalette(img, colorCount, quality)
  }
}
